import * as React from "react";
import { useDispatch, useSelector, statusFailed } from "@grandvisionhq/state";
import { getUnlinkOrderCall } from "../../selectors.js";
import UnlinkView from "./UnlinkView.js";
import { unlinkOrder, unlinkOrderFailed } from "./actions.js";
const UnlinkOrderContainer = ({ isSuccessPage, orderNumber = "", orderToken }) => {
  const dispatch = useDispatch();
  const unlinkOrderCall = useSelector(getUnlinkOrderCall);
  const viewType = React.useMemo(() => {
    if (isSuccessPage) {
      return "success";
    } else {
      return statusFailed(unlinkOrderCall) ? "failed" : void 0;
    }
  }, [isSuccessPage, unlinkOrderCall]);
  React.useEffect(() => {
    if (!isSuccessPage) {
      if (orderToken) {
        dispatch(unlinkOrder({ orderToken, orderNumber }));
      } else {
        dispatch(
          unlinkOrderFailed(
            new Error("Cannot unlink an order without an orderToken")
          )
        );
      }
    }
  }, [dispatch, orderNumber, isSuccessPage, orderToken]);
  return /* @__PURE__ */ React.createElement(UnlinkView, { viewType, unlinkedItemId: orderNumber, unlinkType: "unlinkOrder" });
};
const UnlinkOrderContainer$1 = React.memo(UnlinkOrderContainer);
export {
  UnlinkOrderContainer$1 as default
};
//# sourceMappingURL=UnlinkOrderContainer.js.map
